<form [formGroup]="phoneNumberForm" class="phone-number-form">
  <div class="country-code-input">
    <ion-input
      formControlName="countryCode"
      type="text"
      clearInput="true"
      placeholder="+33"
      minlength="1"
      maxlength="5"></ion-input>
  </div>
  <div class="phone-number-input">
    <ion-input
      formControlName="phoneNumber"
      type="text"
      clearInput="true"
      placeholder="0606060606"
      minlength="1"
      maxlength="15"></ion-input>
  </div>
</form>
